import './CandidateInformationDesktop.scss';
import { Maybe } from 'generated/graphql';
import { FC } from 'react';
import { Modal, ModalSize } from '@spotted-zebra-uk/ui-components';
import CandidateInformationContainer from '../../CandidateInformationContainer/CandidateInformationContainer';

interface ICandidateInformationDesktop {
  onCloseButtonClick: () => void;
  stageCandidateId: number;
  companyLogoUrl?: Maybe<string>;
  onCandidateInformationProvided: () => void;
  onCandidateInformationFormPreviouslyCompleted: () => void;
}

const CandidateInformationDesktop: FC<ICandidateInformationDesktop> = ({
  onCloseButtonClick,
  stageCandidateId,
  companyLogoUrl,
  onCandidateInformationProvided,
  onCandidateInformationFormPreviouslyCompleted,
}) => {
  return (
    //@ts-ignore
    <Modal
      className="CandidateInformationDesktop"
      onClose={onCloseButtonClick}
      isOpen
      modalSize={ModalSize.SMALL}
    >
      <CandidateInformationContainer
        stageCandidateId={stageCandidateId}
        companyLogoUrl={companyLogoUrl}
        onCandidateInformationProvided={onCandidateInformationProvided}
        onCandidateInformationFormPreviouslyCompleted={
          onCandidateInformationFormPreviouslyCompleted
        }
      />
    </Modal>
  );
};

export default CandidateInformationDesktop;
